var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGridShow = function SvgGridShow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gridShow_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    x: 11,
    y: 11,
    rx: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    x: 0.5,
    y: 0.5,
    stroke: "#7A7A7A",
    rx: 18.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gridShow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7A7A7A",
    fillRule: "evenodd",
    d: "M12.139 12.138q-1.067 1.067-1.067 2.576t1.067 2.576 2.575 1.067q1.51 0 2.576-1.067t1.067-2.576q0-1.509-1.067-2.576t-2.576-1.067-2.575 1.067m.707 4.445q-.774-.774-.774-1.869t.774-1.869 1.868-.774 1.87.774q.773.775.773 1.87 0 1.094-.774 1.868t-1.869.774-1.868-.774M20.71 12.138q-1.067 1.067-1.067 2.576t1.067 2.576 2.576 1.067 2.576-1.067 1.067-2.576-1.067-2.576-2.576-1.067q-1.51 0-2.576 1.067m.707 4.445q-.774-.774-.774-1.869t.774-1.869 1.869-.774 1.868.774.775 1.87-.775 1.868-1.868.774-1.87-.774M12.139 20.71q-1.067 1.067-1.067 2.576t1.067 2.576 2.575 1.067q1.51 0 2.576-1.067t1.067-2.576q0-1.51-1.067-2.576t-2.576-1.067q-1.509 0-2.575 1.067m.707 4.445q-.774-.774-.774-1.87 0-1.094.774-1.868t1.868-.774 1.87.774q.773.774.773 1.869t-.774 1.869q-.774.774-1.869.774t-1.868-.774M20.71 20.71q-1.067 1.067-1.067 2.576t1.067 2.576 2.576 1.067 2.576-1.067 1.067-2.576q0-1.51-1.067-2.576t-2.576-1.067q-1.51 0-2.576 1.067m.707 4.445q-.774-.774-.774-1.87 0-1.094.774-1.868t1.869-.774 1.868.774.775 1.869-.775 1.869-1.868.774-1.87-.774"
  }))));
};
export default SvgGridShow;